export default class LicenceFormat {
    public static dateTimeFormat = {
        formatter: function (date) {
            const padZero = (n: Number) => {
                return n < 10 ? "0" + n : "" + n;
            }
            const day = padZero(date.getDate());
            const month = padZero(date.getMonth() + 1);
            const year = date.getFullYear();
            const hours = padZero(date.getHours());
            const minutes = padZero(date.getMinutes());
            const seconds = padZero(date.getSeconds());
            return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
        }
    };
    public static dateFormat = {
        formatter: function (date) {
            const padZero = (n: Number) => {
                return n < 10 ? "0" + n : "" + n;
            }
            const day = padZero(date.getDate());
            const month = padZero(date.getMonth() + 1);
            const year = date.getFullYear();
            return `${day}.${month}.${year}`;
        }
    };
    public static selectBoxDisplayExpr = (item) => {
        return item && `(${item.Code}) ${item.Name}`;
    }
    public static selectBoxDisplayExprOnlyName = (item) => {
        return item && `${item.Name}`;
    }

    public static intEditorOptions = { format: '#', showClearButton: true };
    public static byteEditorOptions = { format: '#', showClearButton: true, min: 0, max: 255 };

}

